<template>
  <div class="newsDetailsPage">
    <img src="../assets/NewsDetails/banner.png" alt="" class="banner">
    <div class="panel">
      <div class="infoTitle">
        {{newsInfo['infoTitle']}}
      </div>
      <div class="infoBrief">
        <div class="title">摘要</div>
        <div class="text">
          <span>{{newsInfo['infoBrief']}}</span>
        </div>
      </div>
      <div class="newsContent" v-html="newsInfo['infoDetail']"></div>
    </div>
  </div>
</template>

<script>
  import {getHttp} from '../../common/http.js'

  export default {
    name: 'NewsDetails',
    data() {
      return {
        newsInfo: {},
        infoId: '',
      }
    },
    activated() {
      let _this = this;
      this.infoId = this.$route.params['infoId'];
      getHttp(this.constants.INTERFACE_LIST.getInformationDetails,
        {
          infoId: this.infoId,
        }).then((res) => {
        this.newsInfo = res;
      }, (e) => {
        _this.$message.error(e.message || '获取内容失败！')
      })
    },
    created() {
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
  @import "../css/NewsDetails.less";
</style>



// WEBPACK FOOTER //
// src/pages/NewsDetails.vue